import withDirection from 'src/settings/withDirection';
import styled from 'styled-components';
import { palette } from 'styled-theme';
import { device } from '@jjj/components';

export const StyledResultItem = styled('div')`
  display: flex;
  align-items: center;
`;

const ResultIconStyles = styled('span')`
  display: flex;
  align-items: center;
  margin-left: ${props => (props['data-rtl'] === 'rtl' ? '8px' : '0')};
  margin-right: ${props => (props['data-rtl'] === 'rtl' ? '0' : '8px')};
  width: 32px;
  height: 32px;
  justify-content: center;
  color: ${palette('grayscale', 7)};

  &.result-icon {
    & svg {
      height: 22px;
      width: 22px;
    }
  }
`;

export const ResultContent = styled('div')`
  display: flex;
  flex-direction: column;
  max-width: 70vw;

  @media ${device.tablet} {
    max-width: 500px;
  }

  & .result-content-title {
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0px;
    color: ${palette('grayscale', 0)};

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
  }

  & .result-content-subtitle {
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0px;
    color: ${palette('text', 2)};

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
  }
`;

const ResultArrowStyles = styled('div')`
  display: flex;
  align-items: center;
  margin-left: ${props => (props['data-rtl'] === 'rtl' ? '0' : 'auto')};
  margin-right: ${props => (props['data-rtl'] === 'rtl' ? 'auto' : '0')};

  svg.result-arrow {
    width: 16px;
    height: 16px;
    transform: ${props => (props['data-rtl'] === 'rtl' ? 'rotate(180deg)' : 'none')};
  }
`;

const AncestorsStyles = styled('div')`
  svg.ancestor-separator-icon {
    margin: 0 5px;
    transform: ${props => (props['data-rtl'] === 'rtl' ? 'rotate(180deg)' : 'none')};
  }

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 100%;
`;

export const ResultIcon = withDirection(ResultIconStyles);
export const ResultArrow = withDirection(ResultArrowStyles);
export const Ancestors = withDirection(AncestorsStyles);
